import React from 'react';
import Landing from './landingpage';
import About from './about';
import Projects from './projects';
import Resume from './resume';
import Contact from './contact';
import {Switch, Route} from 'react-router-dom';

const Main = () => (
    <Switch>
        <Route exact path = '/' component = {Landing}/>
        <Route exact path = '/about' component = {About}/>
        <Route exact path = '/contact' component = {Contact}/>
        <Route exact path = '/resume' component = {Resume}/>
        <Route exact path = '/projects' component = {Projects}/>
    </Switch>

)

export default Main;


// WEBPACK FOOTER //
// ./src/Components/Main.js